import React from "react";

const nameof = <T>(name: keyof T) => name;

const checkComponentType = (child: any, componentName: string): boolean => {
    return React.isValidElement(child) && (child.type as unknown as () => void).name === componentName;
}

const toModel = <TDto, TModel>(source: TDto | undefined | null): TModel => {
    if (!source) {
        return {} as unknown as TModel;
    }
    return {...source} as unknown as TModel;
}

type AnyObject = { [key: string]: any };

function updateModelFromDto(model: AnyObject, dto: AnyObject): void {
    Object.keys(dto).forEach((key) => {
        model[key] = dto[key];
    });
}

export const TypeHelper = {
    checkComponentType,
    nameof,
    toModel,
    updateModelFromDto
}

